import React from 'react';

function NotFound() {
  return <p>There's nothing here: 404!</p>;
}

export default NotFound;
